import { useNode } from '@craftjs/core';
import { TOTPLink } from '@descope/page-editor-components';
import React, { useCallback } from 'react';
import { EditorTOTPLinkSettings } from './EditorTOTPLinkSettings';

const EditorTOTPLink = (props: React.ComponentProps<typeof TOTPLink>) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLAnchorElement) => {
			connect(drag(ref));
		},
		[connect, drag]
	);

	return <TOTPLink ref={refCb} {...props} />;
};

EditorTOTPLink.craft = {
	name: 'TOTP Provision URL',
	props: {
		children: 'Provision URL',
		italic: false,
		typography: 'body1',
		align: 'center',
		fullWidth: false,
		target: '_blank'
	},
	related: {
		settings: EditorTOTPLinkSettings
	}
};

export { EditorTOTPLink };
